<template>
  <el-dropdown @command="actionsHandler($event, params)" trigger="click">
    <el-button icon="el-icon-more" size="mini" type="plain"></el-button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="(item, key) in items" :key="key" :command="item.action" :class="{'border-bottom mb-2': item.borderBottom}">
        <i :class="item.icon"></i> {{ item.label }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  props: {
    actionsHandler: {
      required: true
    },
    items: {
      required: true
    },
    params: {
      required: false,
      default: {}
    }
  }
}
</script>
